import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SortingAscendingIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M8.7071 6.82843V13.4142H6.7071V6.82843L5.41422 8.12132L4 6.70711L7.7071 3L11.4142 6.70711L10 8.12132L8.7071 6.82843Z"
        fill="#0050B3"
        className={styles.interactiveColor}
      />
    </Icon>
  )
}
